<mat-toolbar color="accent">Processing Verifone {{ typeLabel }}</mat-toolbar>

<mat-dialog-content class="!flex flex-col items-center gap-4 py-8">
  <mat-spinner diameter="48" />

  <div class="text-2xl font-bold">
    {{ data.amount | currency }}
  </div>

  <p class="text-center text-slate-600">
    Waiting for customer to complete {{ typeLabel | lowercase }} on terminal
  </p>

  <div class="flex items-center gap-2 text-sm text-slate-500">
    <mat-icon class="icon-sm">point_of_sale</mat-icon>
    <span>{{ data.terminal.name }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none" alignment="center">
    <button mat-stroked-button color="warn" (click)="cancel()">
      Cancel Transaction
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
